import React from 'react';
import { CTAButton } from './CTAButton';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/ccUZSR7RXhwzGEz6ps4xXd/PROYECTOS_Anuales_(1080_x_900_px)_(4).png';
export function HeroSection() {
  const scrollToOffer = () => {
    document.getElementById('oferta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="w-full bg-white py-8 md:py-12 px-4" data-id="element-74">
      <div className="max-w-3xl mx-auto text-center" data-id="element-75">
        <h1 className="text-2xl md:text-4xl font-extrabold text-[#1A1A2E] leading-tight mb-5" data-id="element-76">
          Domina <span className="text-[#FF6B00]" data-id="element-77">inglés práctico</span> este{' '}
          <span className="text-[#FF6B00]" data-id="element-78">2026</span> con el{' '}
          <span className="text-[#FF6B00]" data-id="element-79">material correcto</span>.
        </h1>

        <button onClick={scrollToOffer} className="cursor-pointer mb-5 inline-block" aria-label="Ver oferta" data-id="element-80">
          <img src={PRODUCT_IMAGE} alt="MegaPack Inglés en Acción - 5 Tomos" className="max-w-[200px] md:max-w-[280px] w-full mx-auto hover:scale-105 transition-transform duration-300" data-id="element-81" />
        </button>

        <h2 className="text-xl md:text-2xl font-bold text-[#1A1A2E] mb-3" data-id="element-82">
          Menos teoría. Menos reglas. Más resultados.
        </h2>

        <p className="text-lg md:text-xl text-[#4A4A5A] mb-5 leading-relaxed" data-id="element-83">
          Aprende con un sistema 80/20 diseñado para hispanohablantes:
          vocabulario real, expresiones naturales y práctica diaria.
        </p>

        <div className="flex justify-center mb-4" data-id="element-84">
          <CTAButton text="QUIERO EL MEGAPACK (DESCARGA INMEDIATA)" className="px-6 py-4 text-base md:text-lg" data-id="element-85" />
        </div>

        <p className="text-sm text-[#4A4A5A] italic" data-id="element-86">
          Hecho para adultos ocupados que quieren avanzar sin frustración.
        </p>
      </div>
    </section>;
}